import { useEffect, useState } from "react";

const QuizProtection = ({ children }) => {
  const [devToolsOpen, setDevToolsOpen] = useState(false);

  useEffect(() => {
    const blockKeys = (e) => {
  // F12 — DevTools
  if (e.code === "F12") {
    e.preventDefault();
    return;
  }

  // F7 — Caret browsing
  if (e.code === "F7") {
    e.preventDefault();
    return;
  }

  // Mac: Cmd+Option combos (DevTools)
  if (e.metaKey && e.altKey) {
    const blocked = ["KeyI", "KeyJ", "KeyC", "KeyU", "KeyK"];
    if (blocked.includes(e.code)) {
      e.preventDefault();
      return;
    }
  }

  // Windows/Linux: Ctrl+Shift combos (DevTools)
  if (e.ctrlKey && e.shiftKey) {
    const blocked = ["KeyI", "KeyJ", "KeyC", "KeyK", "KeyM", "KeyS"];
    if (blocked.includes(e.code)) {
      e.preventDefault();
      return;
    }
  }

  // Ctrl/Cmd single key combos
  if (e.ctrlKey || e.metaKey) {
    const blocked = ["KeyC", "KeyA", "KeyU", "KeyS", "KeyP", "KeyG", "KeyH"];
    if (blocked.includes(e.code)) {
      e.preventDefault();
      return;
    }
  }
};

    const blockContext = (e) => e.preventDefault();
    const blockClipboard = (e) => e.preventDefault();
    const blockDrag = (e) => e.preventDefault();
    const blockSelect = () => window.getSelection()?.removeAllRanges();
    const blockPrint = (e) => e.preventDefault();

    // Detect DevTools — sets state instead of destroying DOM
    const detectDevTools = () => {
      const threshold = 160;
      const isOpen =
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold;
      setDevToolsOpen(isOpen);
    };

    const devToolsInterval = setInterval(detectDevTools, 1000);

    document.addEventListener("keydown", blockKeys);
    document.addEventListener("contextmenu", blockContext);
    document.addEventListener("copy", blockClipboard);
    document.addEventListener("cut", blockClipboard);
    document.addEventListener("paste", blockClipboard);
    document.addEventListener("dragstart", blockDrag);
    document.addEventListener("selectstart", blockSelect);
    window.addEventListener("beforeprint", blockPrint);

    return () => {
      document.removeEventListener("keydown", blockKeys);
      document.removeEventListener("contextmenu", blockContext);
      document.removeEventListener("copy", blockClipboard);
      document.removeEventListener("cut", blockClipboard);
      document.removeEventListener("paste", blockClipboard);
      document.removeEventListener("dragstart", blockDrag);
      document.removeEventListener("selectstart", blockSelect);
      window.removeEventListener("beforeprint", blockPrint);
      clearInterval(devToolsInterval);
    };
  }, []);

  // DevTools open — show warning overlay
  if (devToolsOpen) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontFamily: "sans-serif",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "white",
          zIndex: 99999,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h1>⚠️ Not Allowed</h1>
          <p>Please close Developer Tools to continue the quiz.</p>
        </div>
      </div>
    );
  }

  // DevTools closed — show quiz normally
  return (
    <div
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
      }}
    >
      {children}
    </div>
  );
};

export default QuizProtection;